// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Rx8t","right":"Footer_right__1wnBA","buttons":"Footer_buttons__1-z0t"};